import { useState, useCallback } from 'react'

export interface ChartError {
  error: Error | null
  setError: (error: Error | null) => void
  handleError: (err: unknown, context?: string) => void
}

/**
 * Common hook for handling chart errors
 */
export const useChartError = (): ChartError => {
  const [error, setError] = useState<Error | null>(null)

  const handleError = useCallback((err: unknown, context = 'processing chart data') => {
    console.error(`Error ${context}:`, err)
    const errorObj = err instanceof Error ? err : new Error(`Unknown error ${context}`)
    setError(errorObj)
  }, [])

  return {
    error,
    setError,
    handleError
  }
}